import * as utils from "@/utils.js";
import store from "@/store";

export const SetInvestorsProgrammeData = rootState => {
    const investorProgrammeData = {
        ITMO: [],
        creditBancaire: [
            {
                montant: null,
                duree: null,
                taux: null
            },
            {
                montant: null,
                duree: null,
                taux: null
            }
        ],
        capitalSocial: null,
        compteAssocie: null
    };
    const itmo = rootState.EtudeTechnique.itmo;
    let index = 0;
    investorProgrammeData.capitalSocial =
        rootState.VotreProject.entreprise.capitalSocial;

    itmo.forEach(moyen => {
        if (!utils.isExisted("ITMO", investorProgrammeData.ITMO)) {
            investorProgrammeData.ITMO.push({
                name: "ITMO",
                value: parseInt(moyen.prix) * parseInt(moyen.nombre)
            });
        } else {
            index = investorProgrammeData.ITMO.findIndex(
                item => item.name === "ITMO"
            );
            investorProgrammeData.ITMO[index].value +=
                parseInt(moyen.prix) * parseInt(moyen.nombre);
        }
    });

    const constructionsData = rootState.EtudeTechnique.constructionsData;

    constructionsData.forEach(constructionData => {
        if (constructionData.buildingType === "terrain") {
            if (!utils.isExisted("terrain", investorProgrammeData.ITMO)) {
                if (constructionData.isBuying === "Achat") {
                    if (constructionData.hasField) {
                        investorProgrammeData.ITMO.push({
                            name: "terrain",
                            value: parseInt(constructionData.price)
                        });
                    } else {
                        investorProgrammeData.ITMO.push({
                            name: "terrain",
                            value:
                                parseInt(constructionData.price) *
                                parseInt(constructionData.Superficie)
                        });
                    }
                }
            } else {
                index = investorProgrammeData.ITMO.findIndex(
                    item => item.name === "terrain"
                );
                if (constructionData.isBuying === "Achat") {
                    if (constructionData.hasField) {
                        investorProgrammeData.ITMO[index].value += parseInt(
                            constructionData.price
                        );
                    } else {
                        investorProgrammeData.ITMO[index].value +=
                            parseInt(constructionData.price) *
                            parseInt(constructionData.Superficie);
                    }
                }
            }
        }

        if (constructionData.buildingType === "local_pro") {
            if (constructionData.constructionTotal !== null) {
                if (
                    !utils.isExisted(
                        "Aménagement et agencement",
                        investorProgrammeData.ITMO
                    )
                ) {
                    investorProgrammeData.ITMO.push({
                        name: "Aménagement et agencement",
                        value: parseInt(constructionData.constructionTotal)
                    });
                } else {
                    index = investorProgrammeData.ITMO.findIndex(
                        item => item.name === "Aménagement et agencement"
                    );
                    investorProgrammeData.ITMO[index].value += parseInt(
                        constructionData.constructionTotal
                    );
                }
            }
        }
        if (constructionData.buildingType === "bureaux") {
            if (constructionData.constructionTotal !== null) {
                if (
                    !utils.isExisted(
                        "Aménagement et agencement",
                        investorProgrammeData.ITMO
                    )
                ) {
                    investorProgrammeData.ITMO.push({
                        name: "Aménagement et agencement",
                        value: parseInt(constructionData.constructionTotal)
                    });
                } else {
                    index = investorProgrammeData.ITMO.findIndex(
                        item => item.name === "Aménagement et agencement"
                    );
                    investorProgrammeData.ITMO[index].value += parseInt(
                        constructionData.constructionTotal
                    );
                }
            }
        }
    });
    return investorProgrammeData;
};

export const SetInvestorImportedData = rootState => {
    const getInputObject = {
        miscellaneousExpenses: null,
        tangibleAssetsOptions: [],
        intangibleAssetsOptions: [],
        nonValueAssetOptions: [],
        diversImprevue: null,
        capitalSocial: null,
        compteAssocie: null,
        creditBancaire: [
            {
                montant: null,
                duree: null,
                taux: null
            },
            {
                montant: null,
                duree: null,
                taux: null
            }
        ],
        augmentationCapital: null,
        subventions: null,
        leasing: null
    };
    getInputObject.capitalSocial =
        rootState.VotreProject.entreprise.capitalSocial;

    const constructionsData = rootState.EtudeTechnique.constructionsData;
    let index = 0;
    constructionsData.forEach(constructionData => {
        if (constructionData.buildingType === "terrain") {
            if (
                !utils.isExisted(
                    "terrain",
                    getInputObject.tangibleAssetsOptions
                )
            ) {
                if (constructionData.isBuying === "Achat") {
                    if (constructionData.hasField) {
                        getInputObject.tangibleAssetsOptions.push({
                            name: "terrain",
                            value: parseInt(constructionData.price)
                        });
                    } else {
                        getInputObject.tangibleAssetsOptions.push({
                            name: "terrain",
                            value:
                                parseInt(constructionData.price) *
                                parseInt(constructionData.Superficie)
                        });
                    }
                }
            } else {
                index = getInputObject.tangibleAssetsOptions.findIndex(
                    item => item.name === "terrain"
                );
                if (constructionData.isBuying === "Achat") {
                    if (constructionData.hasField) {
                        getInputObject.tangibleAssetsOptions[
                            index
                        ].value += parseInt(constructionData.price);
                    } else {
                        getInputObject.tangibleAssetsOptions[index].value +=
                            parseInt(constructionData.price) *
                            parseInt(constructionData.Superficie);
                    }
                }
            }
            if (
                utils.isThereAValue(constructionData.constructionCosts) ||
                constructionData.constructionTotal !== null
            ) {
                let value = constructionData.constructionTotal;
                if (utils.isThereAValue(constructionData.constructionCosts))
                    value = Object.values(
                        constructionData.constructionCosts
                    ).reduce((a, b) => {
                        if (b.price === null || b.surface === null) return a;
                        return a + parseInt(b.price) * parseInt(b.surface);
                    }, 0);
                if (
                    !utils.isExisted(
                        "Construction bâtiment industriel",
                        getInputObject.tangibleAssetsOptions
                    )
                ) {
                    getInputObject.tangibleAssetsOptions.push({
                        name: "Construction bâtiment industriel",
                        value: parseInt(value)
                    });
                } else {
                    index = getInputObject.tangibleAssetsOptions.findIndex(
                        item => item.name === "Construction bâtiment industriel"
                    );
                    getInputObject.tangibleAssetsOptions[
                        index
                    ].value += parseInt(value);
                }
            }
        }

        if (constructionData.buildingType === "local_pro") {
            if (constructionData.FCD) {
                if (
                    !utils.isExisted(
                        "Fonds commercial",
                        getInputObject.intangibleAssetsOptions
                    )
                ) {
                    getInputObject.intangibleAssetsOptions.push({
                        name: "Fonds commercial",
                        value: parseInt(constructionData.price)
                    });
                } else {
                    index = getInputObject.intangibleAssetsOptions.findIndex(
                        item => item.name === "Fonds commercial"
                    );
                    getInputObject.intangibleAssetsOptions[
                        index
                    ].value += parseInt(constructionData.price);
                }
            }
            if (constructionData.constructionTotal !== null) {
                if (
                    !utils.isExisted(
                        "Aménagement et agencement",
                        getInputObject.tangibleAssetsOptions
                    )
                ) {
                    getInputObject.tangibleAssetsOptions.push({
                        name: "Aménagement et agencement",
                        value: parseInt(constructionData.constructionTotal)
                    });
                } else {
                    index = getInputObject.tangibleAssetsOptions.findIndex(
                        item => item.name === "Aménagement et agencement"
                    );
                    getInputObject.tangibleAssetsOptions[
                        index
                    ].value += parseInt(constructionData.constructionTotal);
                }
            }
        }
        if (constructionData.buildingType === "bureaux") {
            if (constructionData.constructionTotal !== null) {
                if (
                    !utils.isExisted(
                        "Aménagement et agencement",
                        getInputObject.tangibleAssetsOptions
                    )
                ) {
                    getInputObject.tangibleAssetsOptions.push({
                        name: "Aménagement et agencement",
                        value: parseInt(constructionData.constructionTotal)
                    });
                } else {
                    index = getInputObject.tangibleAssetsOptions.findIndex(
                        item => item.name === "Aménagement et agencement"
                    );
                    getInputObject.tangibleAssetsOptions[
                        index
                    ].value += parseInt(constructionData.constructionTotal);
                }
            }
            if (constructionData.isBuying === "Leasing") {
                getInputObject.leasing +=
                    parseInt(constructionData.payedInAdvance) +
                    parseInt(constructionData.rent) *
                        parseInt(constructionData.rentDuration);
            }
        }
    });

    const techInstallations = rootState.EtudeTechnique.techInstallations;

    techInstallations.forEach(installation => {
        if (!installation.isBuying) {
            getInputObject.leasing +=
                parseInt(installation.payedInAdvance) +
                parseInt(installation.rentPrice) *
                    parseInt(installation.rentDuration);
        }

        if (installation.isBuying) {
            if (
                !utils.isExisted(
                    "Installations techniques",
                    getInputObject.tangibleAssetsOptions
                )
            ) {
                getInputObject.tangibleAssetsOptions.push({
                    name: "Installations techniques",
                    value:
                        parseInt(installation.price) *
                        parseInt(installation.number)
                });
            } else {
                index = getInputObject.tangibleAssetsOptions.findIndex(
                    item => item.name === "Installations techniques"
                );
                getInputObject.tangibleAssetsOptions[index].value +=
                    parseInt(installation.price) *
                    parseInt(installation.number);
            }
        }
    });

    const transportation = rootState.EtudeTechnique.transportation;

    transportation.forEach(installation => {
        if (installation.BuyingType === "leasing") {
            getInputObject.leasing +=
                parseInt(installation.payedInAdvance) +
                parseInt(installation.rentPrice) *
                    parseInt(installation.rentDuration);
        }

        if (installation.BuyingType === "achat") {
            if (
                !utils.isExisted(
                    "Matériel de transport",
                    getInputObject.tangibleAssetsOptions
                )
            ) {
                getInputObject.tangibleAssetsOptions.push({
                    name: "Matériel de transport",
                    value:
                        parseInt(installation.price) *
                        parseInt(installation.number)
                });
            } else {
                index = getInputObject.tangibleAssetsOptions.findIndex(
                    item => item.name === "Matériel de transport"
                );
                getInputObject.tangibleAssetsOptions[index].value +=
                    parseInt(installation.price) *
                    parseInt(installation.number);
            }
        }
    });

    const furnitureCard = rootState.EtudeTechnique.furnitureCard;

    furnitureCard.forEach(installation => {
        if (
            !utils.isExisted(
                "Mobilier de bureau",
                getInputObject.tangibleAssetsOptions
            )
        ) {
            getInputObject.tangibleAssetsOptions.push({
                name: "Mobilier de bureau",
                value:
                    parseInt(installation.prix) * parseInt(installation.nombre)
            });
        } else {
            index = getInputObject.tangibleAssetsOptions.findIndex(
                item => item.name === "Mobilier de bureau"
            );
            getInputObject.tangibleAssetsOptions[index].value +=
                parseInt(installation.prix) * parseInt(installation.nombre);
        }
    });

    const techHardware = rootState.EtudeTechnique.techHardware;

    techHardware.forEach(installation => {
        if (
            !utils.isExisted(
                "Matériel informatique",
                getInputObject.tangibleAssetsOptions
            )
        ) {
            getInputObject.tangibleAssetsOptions.push({
                name: "Matériel informatique",
                value:
                    parseInt(installation.prix) * parseInt(installation.nombre)
            });
        } else {
            index = getInputObject.tangibleAssetsOptions.findIndex(
                item => item.name === "Matériel informatique"
            );

            getInputObject.tangibleAssetsOptions[index].value +=
                parseInt(installation.prix) * parseInt(installation.nombre);
        }
    });

    const tools = rootState.EtudeTechnique.tools;

    tools.forEach(tool => {
        if (!tool.isBuying) {
            getInputObject.leasing +=
                parseInt(tool.payedInAdvance) +
                parseInt(tool.rentPrice) * parseInt(tool.rentDuration);
        }

        if (tool.isBuying) {
            if (
                !utils.isExisted(
                    "Matériel et outillage",
                    getInputObject.tangibleAssetsOptions
                )
            ) {
                getInputObject.tangibleAssetsOptions.push({
                    name: "Matériel et outillage",
                    value: parseInt(tool.price) * parseInt(tool.number)
                });
            } else {
                index = getInputObject.tangibleAssetsOptions.findIndex(
                    item => item.name === "Matériel et outillage"
                );
                getInputObject.tangibleAssetsOptions[index].value +=
                    parseInt(tool.price) * parseInt(tool.number);
            }
        }
    });

    store.dispatch("EtudeFinanciere/SaveImportedData", getInputObject);
    return getInputObject;
};

export const SetOtherChargeImportedData = (
    rootState,
    isRootState = true,
    step = null
) => {
    const otherChargeResult = [];
    let index = 0;
    if (isRootState || step === "construction") {
        let constructionsData;
        if (isRootState) {
            constructionsData = rootState.EtudeTechnique.constructionsData;
        } else {
            constructionsData = rootState;
        }
        constructionsData.forEach(constructionData => {
            if (constructionData.isBuying === "Location") {
                if (
                    !utils.isExisted(
                        "Location et charges locatives",
                        otherChargeResult
                    )
                ) {
                    otherChargeResult.push({
                        name: "Location et charges locatives",
                        value: parseInt(constructionData.rent) * 12
                    });
                } else {
                    index = otherChargeResult.findIndex(
                        item => item.name === "Location et charges locatives"
                    );
                    otherChargeResult[index].value +=
                        parseInt(constructionData.rent) * 12;
                }
            }
            if (constructionData.isBuying === "Leasing") {
                if (
                    !utils.isExisted(
                        "Redevances crédit de bail",
                        otherChargeResult
                    )
                ) {
                    if (parseInt(constructionData.rentDuration) >= 12) {
                        otherChargeResult.push({
                            name: "Redevances crédit de bail",
                            value: parseInt(constructionData.rent) * 12
                        });
                    } else {
                        otherChargeResult.push({
                            name: "Redevances crédit de bail",
                            value:
                                parseInt(constructionData.rent) *
                                parseInt(constructionData.rentDuration)
                        });
                    }
                } else {
                    index = otherChargeResult.findIndex(
                        item => item.name === "Redevances crédit de bail"
                    );
                    if (parseInt(constructionData.rentDuration) >= 12) {
                        otherChargeResult[index].value +=
                            parseInt(constructionData.rent) * 12;
                    } else {
                        otherChargeResult[index].value +=
                            parseInt(constructionData.rent) *
                            parseInt(constructionData.rentDuration);
                    }
                }
            }
        });
    }
    if (isRootState || step === "transportation") {
        let transportation;
        if (isRootState) {
            transportation = rootState.EtudeTechnique.transportation;
        } else {
            transportation = rootState;
        }

        transportation.forEach(transportation => {
            if (transportation.BuyingType === "location") {
                if (
                    !utils.isExisted(
                        "Location et charges locatives",
                        otherChargeResult
                    )
                ) {
                    otherChargeResult.push({
                        name: "Location et charges locatives",
                        value: parseInt(transportation.rentPrice) * 12
                    });
                } else {
                    index = otherChargeResult.findIndex(
                        item => item.name === "Location et charges locatives"
                    );
                    otherChargeResult[index].value +=
                        parseInt(transportation.rentPrice) * 12;
                }
            }

            if (transportation.BuyingType === "leasing") {
                if (
                    !utils.isExisted(
                        "Redevances crédit de bail",
                        otherChargeResult
                    )
                ) {
                    if (parseInt(transportation.rentDuration) >= 12) {
                        otherChargeResult.push({
                            name: "Redevances crédit de bail",
                            value: parseInt(transportation.rentPrice) * 12
                        });
                    } else {
                        otherChargeResult.push({
                            name: "Redevances crédit de bail",
                            value:
                                parseInt(transportation.rentPrice) *
                                parseInt(transportation.rentDuration)
                        });
                    }
                } else {
                    index = otherChargeResult.findIndex(
                        item => item.name === "Redevances crédit de bail"
                    );
                    if (parseInt(transportation.rentDuration) >= 12) {
                        otherChargeResult[index].value +=
                            parseInt(transportation.rentPrice) * 12;
                    } else {
                        otherChargeResult[index].value +=
                            parseInt(transportation.rentPrice) *
                            parseInt(transportation.rentDuration);
                    }
                }
            }
        });
    }

    if (isRootState || step === "techInstallations") {
        let techInstallations;
        if (isRootState) {
            techInstallations = rootState.EtudeTechnique.techInstallations;
        } else {
            techInstallations = rootState;
        }
        techInstallations.forEach(techInstallations => {
            if (!techInstallations.isBuying) {
                if (
                    !utils.isExisted(
                        "Redevances crédit de bail",
                        otherChargeResult
                    )
                ) {
                    if (parseInt(techInstallations.rentDuration) >= 12) {
                        otherChargeResult.push({
                            name: "Redevances crédit de bail",
                            value: parseInt(techInstallations.rentPrice) * 12
                        });
                    } else {
                        otherChargeResult.push({
                            name: "Redevances crédit de bail",
                            value:
                                parseInt(techInstallations.rentPrice) *
                                parseInt(techInstallations.rentDuration)
                        });
                    }
                } else {
                    index = otherChargeResult.findIndex(
                        item => item.name === "Redevances crédit de bail"
                    );
                    if (parseInt(techInstallations.rentDuration) >= 12) {
                        otherChargeResult[index].value +=
                            parseInt(techInstallations.rentPrice) * 12;
                    } else {
                        otherChargeResult[index].value +=
                            parseInt(techInstallations.rentPrice) *
                            parseInt(techInstallations.rentDuration);
                    }
                }
            }
        });
    }

    if (isRootState || step === "tools") {
        let tools;
        if (isRootState) {
            tools = rootState.EtudeTechnique.tools;
        } else {
            tools = rootState;
        }
        tools.forEach(tools => {
            if (!tools.isBuying) {
                if (
                    !utils.isExisted(
                        "Redevances crédit de bail",
                        otherChargeResult
                    )
                ) {
                    if (parseInt(tools.rentDuration) >= 12) {
                        otherChargeResult.push({
                            name: "Redevances crédit de bail",
                            value: parseInt(tools.rentPrice) * 12
                        });
                    } else {
                        otherChargeResult.push({
                            name: "Redevances crédit de bail",
                            value:
                                parseInt(tools.rentPrice) *
                                parseInt(tools.rentDuration)
                        });
                    }
                } else {
                    index = otherChargeResult.findIndex(
                        item => item.name === "Redevances crédit de bail"
                    );
                    if (parseInt(tools.rentDuration) >= 12) {
                        otherChargeResult[index].value +=
                            parseInt(tools.rentPrice) * 12;
                    } else {
                        otherChargeResult[index].value +=
                            parseInt(tools.rentPrice) *
                            parseInt(tools.rentDuration);
                    }
                }
            }
        });
    }
    if (isRootState) {
        store.dispatch("EtudeFinanciere/SaveOtherChargeImportedData", {
            otherChargeResult: otherChargeResult,
            tauxDevolution: null
        });
    }

    return {
        otherChargeResult: otherChargeResult,
        tauxDevolution: null
    };
};
